import jose from "node-jose";

export const enctyptionImplementedRoute = [
  "/api/auth/login",
  "/api/setting/change-password",
  "/api/auth/forgot-password-account-confirm",
  "/api/account/getAccountDetails",
  "/api/auth/forgotPasswordAccountConfirm",
  "/api/auth/forgotPasswordChangeValue",
  "/api/setting/authenticate",
  "/api/setting/change-passcode-validate",
  "/api/setting/change-passcode",
  "/api/setting/change-passcode-otp-resend",
  "/api/setting/change-passcode-otp-confirm",
  "/api/auth/add-profile-info",
  "/api/auth/debit-card-pre-register",
  "/api/auth/expiredPasswordChangeValue",
  "/api/trafficFines/payBill",
  "/api/fundTransfers/intiate",
  "/api/creditCardPayments/validateAmount",
];

export const getPublicKey = () => {
  const publicKey = localStorage.getItem("publicKey");
  if (typeof publicKey != "undefined") {
    return publicKey;
  }

  return false;
};

export const encryptText = async (payload) => {
  let publicKey = getPublicKey();
  if (publicKey != false) {
    publicKey = JSON.parse(publicKey);
    const key = await jose.JWK.asKey(publicKey);
    const encryptor = jose.JWE.createEncrypt({ format: "compact" }, key);
    const encryptedResult = await encryptor
      .update(JSON.stringify(payload), "utf8")
      .final();

    return encryptedResult;
  }

  return null;
};

export const payloadFormatter = async (payload, route) => {
  if (enctyptionImplementedRoute.includes(route)) {
    const encryptedTxt = await encryptText(payload);

    return { encryptedTxt: encryptedTxt };
  }
  return payload;
};
